export default __webpack_public_path__ + "static/media/driving-license-preview-icon.1af8af11.svg";